import React from "react";
import Swal from "sweetalert2";
import "./PrivacySettings.css";

const PrivacySettings = ({ onLogout }) => {

    const handleDeleteAccount = () => {
        Swal.fire({
            title: 'Žal nam je, da odhajaš :(',
            html: `<p>Prosimo povej nam zakaj odhajaš:</p>
                   <textarea id="reason" class="swal2-textarea" placeholder="Razlog..."></textarea>`,
            showCancelButton: true,
            confirmButtonText: 'Izbriši račun',
            cancelButtonText: 'Prekliči',
            preConfirm: () => {
                const reason = document.getElementById('reason').value;
                if (!reason) {
                    Swal.showValidationMessage('Prosimo povejte razlog, preden nadaljujete.');
                }
                return reason;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const reason = result.value;
                console.log('Reason for leaving:', reason);

                // Show success message for account deletion
                Swal.fire('Račun uspešno izbrisan.', 'Tvoj račun in podatki so bili uspešno izbrisani.', 'success');
                
                // Now log out the user when the account is "deleted"
                onLogout(); // Call the onLogout function passed from UserDashboard to log out
            }
        });
    };

    return (
        <div className="privacy_settings">
            <h2>Nastavitve zasebnosti</h2>
            <hr className="hr_privacy_settings" />

            <div className="settings_container">
                <div className="left_section">
                    <label className="checkbox_label">
                        <input type="checkbox" />
                        Želim prejemati MatZab glasila
                    </label>
                    <label className="checkbox_label">
                        <input type="checkbox" />
                        Želim prejemati sporočila uporabnikov na e-pošto
                    </label>
                </div>

                <div className="right_section">
                    <button className="delete_account_button" onClick={handleDeleteAccount}>Izbris računa</button>
                </div>
            </div>
        </div>
    );
};

export default PrivacySettings;